import { useState, useEffect } from "react";
import "./loadingSpinner.css";

const loadingMessages = [
  "Zoekresultaten worden geladen...",
  "Er wordt gezocht in een database met 2 miljoen boeken...",
  // "Boeken worden afgestoft...",
  // "We bladeren door de catalogus...",
  // "Op zoek naar dat perfecte boek...",
  // "De planken worden doorzocht...",
  // "Even de kaftjes schoonvegen...",
  // "Pagina's worden omgeslagen...",
  // "De leesbril wordt opgezet...",
  // "Even door de index bladeren...",
  // "De boekenkast wordt doorzocht...",
];

export default function LoadingSpinner() {
  const [currentMessageIndex, setCurrentMessageIndex] = useState(0);

  useEffect(() => {
    // Start met de eerste (vaste) message
    setCurrentMessageIndex(0);

    const interval = setInterval(() => {
      setCurrentMessageIndex((prev) => {
        let newIndex;
        do {
          newIndex = Math.floor(Math.random() * loadingMessages.length);
        } while (newIndex === prev); // Zorg dat het niet dezelfde blijft
        return newIndex;
      });
    }, 3500); // Elke ~3.5 seconden een nieuwe random tekst

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="loading-spinner">
      <div className="spinner" />

      {/* Boek-icoontje (SVG) */}
      <svg
        className="loading-book-icon"
        xmlns="http://www.w3.org/2000/svg"
        width="48"
        height="48"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
        <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
      </svg>

      <p itemID="search-results-loading" className="loading-text">
        {loadingMessages[currentMessageIndex]}
      </p>
    </div>
  );
}